import React, { useRef, useEffect, useState } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faCar, faTruck, faTachometerAlt, faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import ReactEcharts from 'echarts-for-react';
import { NavLink } from 'react-router-dom';

import API_PATH from "../../constants/config.json";
import { setCookie, getPrivileges } from './../../functions/Auth';
import '../../scss/components/_popupTemplate.scss';

const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;

let title = "";
let content = [];
let value_left=0;
let midblockChecked=false;
let intersectionChecked=false;
let searchChecked=false


const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

//Start MidBlock component code ...
const PopupTemplate = props => {
    
   title = props.title;
   content = props.content;
   
   midblockChecked={midblockChecked}
   intersectionChecked={intersectionChecked}
   searchChecked={searchChecked}
   value_left=-2 
   if(props.showExternalLayers){
    value_left=300
   }

   if(props.midblockChecked ||props.intersectionChecked || props.searchChecked ){
    value_left=value_left+505
   }

  let msWidth = window.innerHeight;


  // This code is use to get window viewport height
  if (window.screen.width >= 100 && window.screen.width <= 1500) {
    msWidth = window.innerWidth;
  }
  else if (window.screen.width >= 1501 && window.screen.width <= 3500) {
    msWidth = window.innerWidth;
  }
  else if (window.screen.width >= 3501) {
    msWidth = window.innerWidth;
  }
  else {
    msWidth = window.innerWidth;
  }
  // This code is use to get window viewport height

  useEffect(() => {

  }, []);

  const [popuptemplateScreenWidth, setPopuptemplateScreenWidth] = React.useState(msWidth);
  const myRef = useRef(null);
  const tableBodyRef = useRef();

  const [scrolled, setScrolled] = useState(false);

  // This code is use to change window viewport height
  window.onresize = function () {
    if (window.screen.width >= 100 && window.screen.width <= 1500) {
      msWidth = window.innerWidth;
      setPopuptemplateScreenWidth(msWidth);
    }
    else if (window.screen.width >= 1501 && window.screen.width <= 3500) {
      msWidth = window.innerWidth;
      setPopuptemplateScreenWidth(msWidth);
    }
    else if (window.screen.width >= 3501) {
      msWidth = window.innerWidth;
      setPopuptemplateScreenWidth(msWidth);
    }
    else {
      msWidth = window.innerWidth;
      setPopuptemplateScreenWidth(msWidth);
    }
  };
  // This code is use to change window viewport height

  const handleScroll = () => {
    if (tableBodyRef.current) {
      const { scrollTop } = tableBodyRef.current;
      if (scrollTop > 0) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    }
};

  return (
    <React.Fragment>
      <CssBaseline />
      <div className="midBlock" ref={myRef} style={{left:value_left+'px'}}>
        <Container maxWidth="sm" className={['midBlockContainer', "container", "midMainContainer"]}>
          <div className="formHead">
            <p className="closeIcon" onClick={props.passPopValue}>
              <FontAwesomeIcon icon={faAngleLeft} className="btnIcons" title='Close' /> <label>Back</label>
            </p>
            <p className="layerTitle" > {title} </p>
            <TableContainer component={Paper}  className="tableProperties">
                <Table className="tableMidBlock" aria-label="customized table">
                <TableHead className={scrolled ? "table-scrolled" : null}>
                    <StyledTableRow>
                        <TableCell>Property</TableCell>
                        <TableCell>Value</TableCell>
                    </StyledTableRow>
                </TableHead>
                <TableBody id="tableBody" onScroll={handleScroll} ref={tableBodyRef}>
                    { 
                        content.map(function(item, i){
                            return (<StyledTableRow>
                                <TableCell>
                                {item[0]}
                                </TableCell>
                                <TableCell>
                                {item[1]}
                                </TableCell>
                            </StyledTableRow>)      
                        })
                    }
                </TableBody>
                </Table>
            </TableContainer> 
            </div>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default PopupTemplate;

//End MidBlock component code ...
